export default "__VITE_ASSET__C3JYjjT3__"